export function OnlyNumbers(event: any, dot: boolean = false) {
  let code = event.which;
  console.log('code: ', code);
  if (dot) {
    if ((code > 47 && code < 58) || code == 46) return true;
    else return false;
  }
  else {
    if (code > 47 && code < 58) return true;
    else return false;
  }
}